import React, { useContext } from 'react';
import MenuItem from '@mui/material/MenuItem';
import RestoreIcon from '@mui/icons-material/Restore';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MuiDialog from '../../SystemDesign/MuiDialog';
import { useDispatch } from 'react-redux';
import { usePutUsersUpdateByUserIdMutation } from '../../services/SkillsManagement';
import { RESTORE_USER_COMPANY, RESTORE_EMPLOYEE } from '../../Reducers/Actions';
import { SnackBarContext } from '../../Context/SnackBarContextProvider';

const RestoreUserCompany = ({ row }) => {
  const user = row.original;
  const dispatch = useDispatch();
  const [updateUserCompany] = usePutUsersUpdateByUserIdMutation();
  const { setInfoAlert, setOpenSnackBar } = useContext(SnackBarContext);

  const handleRestore = async () => {
    try {
      await updateUserCompany({
        userId: user.id,
        type: 'user',
        body: {
          isArchived: false
        }
      }).unwrap();
      
      dispatch({ type: RESTORE_USER_COMPANY, userId: user.id });
      // Also update employees slice used by UserCompanyList to remove from archived view
      dispatch({ type: RESTORE_EMPLOYEE, userId: user.id });
      setInfoAlert({ 
        severity: 'success', 
        message: `User ${user.username} has been restored successfully` 
      });
      setOpenSnackBar(true);
      return true;
    } catch (error) {
      setInfoAlert({ 
        severity: 'error', 
        message: `Error restoring user ${user.username}` 
      });
      setOpenSnackBar(true);
      return false;
    }
  };

  const triggerButton = (
    <MenuItem>
      <ListItemIcon>
        <RestoreIcon fontSize="small" />
      </ListItemIcon>
      <ListItemText>Restore</ListItemText>
    </MenuItem>
  );

  const dialogContent = (
    <div>
      <p>Are you sure you want to restore this user?</p>
    </div>
  );

  return (
    <MuiDialog
      icon={<RestoreIcon />}
      triggerButton={triggerButton}
      title="Restore user"
      subtitle={`You are about to restore ${user.username || "user"}`}
      content={dialogContent}
      existAction={true}
      actionTitle="Restore"
      actionFunction={handleRestore}
      actionType="button"
    />
  );
};

export default RestoreUserCompany;
